import React from 'react';
import { Box, Button, CircularProgress, Stack, Typography } from '@mui/material';
import { TakeoverLayout } from '_lex/_layouts/TakeoverLayout';
import { translate as t } from 'hooks/useTranslations';
import { useEisRuleConfigContext } from './context';
import ConfigurationSection from './components/ConfigurationSection';
import FrequencySection from './components/FrequencySection';
import ManageScoring from './components/ManageScoring';
import ThresholdSection from './components/ThresholdSection';
import NotificationsSection from './components/NotificationsSection';

const RuleConfiguration: React.FC = () => {
  const { configuration, isLoading, isSaving, isPublishing, ruleType, handleSaveDraft, handlePublish, handleBack } =
    useEisRuleConfigContext();

  return (
    <TakeoverLayout
      pageTitle={t('performanceReporting.eis.configuration.pageTitle')}
      onBackClick={handleBack}
      contentBackground='neutral'
      contentHeaderLeft={
        configuration?.rule?.name ? <Typography variant='subtitleLg'>{configuration.rule.name}</Typography> : undefined
      }
      contentHeaderRight={
        <Stack
          direction='row'
          spacing={1}
        >
          <Button
            variant='outlined'
            color='primary'
            onClick={handleSaveDraft}
            loading={isSaving}
            loadingPosition='end'
          >
            {t('performanceReporting.eis.configuration.buttons.saveDraft')}
          </Button>
          <Button
            variant='contained'
            color='primary'
            onClick={handlePublish}
            loading={isPublishing}
            loadingPosition='end'
          >
            {t('performanceReporting.eis.configuration.buttons.publishRule')}
          </Button>
        </Stack>
      }
    >
      {isLoading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', pt: 6 }}>
          <CircularProgress />
        </Box>
      ) : (
        <Box sx={{ maxWidth: 1200, mx: 'auto', width: '100%' }}>
          <Stack
            spacing={2}
            sx={{ width: '100%', py: 3 }}
          >
            {ruleType === 'Frequency' ? (
              <Stack spacing={2}>
                <ConfigurationSection
                  title={t('performanceReporting.eis.configuration.configureFrequency.title')}
                  subtitle={t('performanceReporting.eis.configuration.configureFrequency.subtitle')}
                  defaultExpanded
                >
                  <FrequencySection />
                </ConfigurationSection>

                <ConfigurationSection
                  title={t('performanceReporting.eis.configuration.setNotifications.title')}
                  subtitle={t('performanceReporting.eis.configuration.setNotifications.subtitle')}
                >
                  <NotificationsSection />
                </ConfigurationSection>
              </Stack>
            ) : (
              <>
                <ConfigurationSection
                  title={t('performanceReporting.eis.configuration.manageScoring.title')}
                  subtitle={t('performanceReporting.eis.configuration.manageScoring.subtitle')}
                  defaultExpanded
                >
                  <ManageScoring />
                </ConfigurationSection>

                <ConfigurationSection
                  title={t('performanceReporting.eis.configuration.configureThreshold.title')}
                  subtitle={t('performanceReporting.eis.configuration.configureThreshold.subtitle')}
                >
                  <ThresholdSection />
                </ConfigurationSection>

                <ConfigurationSection
                  title={t('performanceReporting.eis.configuration.setNotifications.title')}
                  subtitle={t('performanceReporting.eis.configuration.setNotifications.subtitle')}
                >
                  <NotificationsSection />
                </ConfigurationSection>
              </>
            )}
          </Stack>
        </Box>
      )}
    </TakeoverLayout>
  );
};

export default RuleConfiguration;
